<kendo-dialog title="Edit Student Profile" (close)="closeDailog()" [width]="786" [height]="'auto'" [maxHeight]="'90vh'"
    [formGroup]="form" *ngIf="form">

    <div class="loading-container" *ngIf="loadSpinner">
        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
    </div>

    <!-- Basic Information -->
    <div class="subsection">
        <h4 class="subsection__heading">Basic</h4>

        <div class="contact-details-container">
            <div class="info-container">
                <kendo-formfield>
                    <kendo-floatinglabel text="First Name *">
                        <kendo-textbox formControlName="firstName" />
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('firstName')?.hasError('required')">
                        Error: Field is required
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield>
                    <kendo-floatinglabel text="Middle Name">
                        <kendo-textbox formControlName="middleName" />
                    </kendo-floatinglabel>
                    <kendo-formerror>{{ form.get('middleName')?.errors?.validateName?.message }}</kendo-formerror>
                </kendo-formfield>
            </div>

            <div class="info-container">
                <kendo-formfield>
                    <kendo-floatinglabel text="Last Name *">
                        <kendo-textbox formControlName="lastName" />
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('lastName')?.hasError('required')">
                        Error: Field is required
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield>
                    <kendo-floatinglabel text="Date of Birth *">
                        <kendo-datepicker calendarType="classic" #dob formControlName="dateOfBirth" format="MM/dd/yyyy"
                            [min]="twentyOneYearsAgo" [max]="threeYearsAgo"
                            (valueChange)="onDOBChange()"></kendo-datepicker>
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form?.controls?.dateOfBirth?.errors?.required">
                        Error: Field is required
                    </kendo-formerror>
                    <kendo-formerror
                        *ngIf="form?.controls?.dateOfBirth?.errors?.minError || form?.controls?.dateOfBirth?.errors?.maxError">Invalid
                        Date of Birth</kendo-formerror>
                </kendo-formfield>

            </div>
        </div>
    </div>

    <div class="divider"></div>

    <!-- Identity Section -->
    <div class="subsection">
        <h4 class="subsection__heading">Identity</h4>

        <div class="contact-details-container">
            <div class="info-container">
                <kendo-formfield>
                    <kendo-floatinglabel text="Gender">
                        <kendo-dropdownlist [data]="referenceData?.sex" textField="description" formControlName="gender"
                            valueField="value">
                        </kendo-dropdownlist>
                    </kendo-floatinglabel>
                </kendo-formfield>

                <kendo-formfield>
                    <kendo-floatinglabel text="Home Language">
                        <kendo-dropdownlist [data]="referenceData?.language" textField="description"
                            formControlName="homeLanguage" valueField="value">
                        </kendo-dropdownlist>
                    </kendo-floatinglabel>
                </kendo-formfield>
            </div>

            <div class="info-container">
                <kendo-formfield>
                    <div id="hispanicFlagLabel">Is the student Hispanic, Latino, or of Spanish origin?
                    </div>
                    <ul role="radiogroup" aria-labelledby="hispanicFlagLabel">
                        <li class="k-radio-item">
                            <input type="radio" name="hispanicFlag" value="Y" #hispanicFlagYes
                                formControlName="hispanicFlag" kendoRadioButton />
                            <kendo-label [for]="hispanicFlagYes" text="Yes"></kendo-label>
                        </li>
                        <li class="k-radio-item">
                            <input type="radio" name="hispanicFlag" value="N" #hispanicFlagNo
                                formControlName="hispanicFlag" kendoRadioButton />
                            <kendo-label [for]="hispanicFlagNo" text="No"></kendo-label>
                        </li>
                    </ul>
                </kendo-formfield>

                <kendo-formfield>
                    <kendo-floatinglabel text="Ethnicity">
                        <kendo-multiselect [data]="referenceData?.ethnicity" textField="description"
                            formControlName="ethnicity" valueField="value">
                        </kendo-multiselect>
                    </kendo-floatinglabel>
                </kendo-formfield>
            </div>
        </div>
    </div>

    <div class=" divider">
    </div>

    <!-- Communication Section -->
    <div class="subsection">
        <h4 class="subsection__heading">Communication</h4>

        <div class="info-container">
            <kendo-formfield>
                <kendo-floatinglabel text="Phone Number">
                    <kendo-maskedtextbox formControlName="phoneNumber" mask="(000) 000-0000"></kendo-maskedtextbox>
                </kendo-floatinglabel>
                <kendo-formerror>{{form.get("phoneNumber")?.errors?.validatePhoneNumberMaskedTextBox?.message}}</kendo-formerror>
            </kendo-formfield>

            <kendo-formfield>
                <kendo-floatinglabel text="Email">
                    <kendo-textbox formControlName="email"></kendo-textbox>
                    <kendo-formerror>{{form.get("email")?.errors?.validateEmail?.message}}</kendo-formerror>
                </kendo-floatinglabel>
            </kendo-formfield>
        </div>
    </div>

    <div class="divider"></div>

    <!-- Housing Information -->
    <div class="subsection">
        <h4 class="subsection__heading">Housing</h4>

        <div class="contact-details-container">
            <div class="info-container">
                <kendo-formfield class="address-fields">
                    <kendo-floatinglabel text="Street Number *">
                        <kendo-textbox formControlName="streetNumber" />
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('streetNumber')?.hasError('required')">
                        Error: Field is required
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield>
                    <kendo-floatinglabel text="Street Name *">
                        <kendo-textbox formControlName="streetName" />
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('streetName')?.hasError('required')">
                        Error: Field is required
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield class="address-fields">
                    <kendo-floatinglabel text="Apartment Number">
                        <kendo-textbox formControlName="apartmentNo" />
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('apartmentNo').errors?.maxlength">Error: Maximum length of 30 characters exceeded</kendo-formerror>
                </kendo-formfield>
            </div>

            <div class="info-container">
                <kendo-formfield class="address-fields">
                    <kendo-floatinglabel text="Home Borough *">
                        <kendo-dropdownlist [data]="referenceData?.borough" textField="description"
                            formControlName="borough" valueField="value">
                        </kendo-dropdownlist>
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('borough')?.hasError('required')">
                        Error: Field is required
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield>
                    <kendo-floatinglabel text="City *">
                        <kendo-textbox formControlName="city" />
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('city')?.hasError('required')">
                        Error: Field is required
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield class="address-fields">
                    <kendo-floatinglabel [text]="isHomeDistrictRequired ? 'Home District *' : 'Home District'">
                        <kendo-dropdownlist [data]="referenceData?.district" textField="description"
                            formControlName="district" valueField="value">
                        </kendo-dropdownlist>
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('district')?.hasError('required')">
                        Error: Field is required
                    </kendo-formerror>
                </kendo-formfield>
            </div>

            <div class="info-container">
                <kendo-formfield>
                    <kendo-floatinglabel text="State *">
                        <kendo-dropdownlist [data]="referenceData?.state" textField="description" valueField="value"
                            formControlName="state">
                        </kendo-dropdownlist>
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('state')?.hasError('required')">
                        Error: Field is required
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield>
                    <kendo-floatinglabel text="Zip *">
                        <kendo-textbox formControlName="zip" />
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('zip')?.hasError('required')">
                        Error: Field is required
                    </kendo-formerror>
                    <kendo-formhint>Formats: 12345, 12345-6789, 12345 6789, or
                        123456789</kendo-formhint>
                </kendo-formfield>
            </div>
        </div>
    </div>

    <kendo-dialog-actions [layout]="'stretched'">
        <button kendoButton fillMode="solid" themeColor="primary" [disabled]="!form.valid || loadSpinner"
            (click)="save()">
            Save
        </button>
    </kendo-dialog-actions>
</kendo-dialog>